import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { MdfRequestComment } from "./types";

// Read the comment thread on a submitted MDF request. Returns BOTH
// partner-authored and internal-authored comments — bucket 10 will start
// inserting internal rows; bucket 9 only ships partner-side adds.
export function useMdfComments(requestId: string | null) {
  return useQuery<MdfRequestComment[]>({
    queryKey: queryKeys.mdf.requestComments(requestId ?? ""),
    queryFn: () =>
      apiFetch<MdfRequestComment[]>(
        `/portal/mdf/requests/${requestId}/comments`,
      ),
    enabled: !!requestId,
  });
}
